module.exports = __webpack_public_path__ + "static/media/chart_2.94b44f60.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Problems/img/chart_2.gif
// module id = 264
// module chunks = 0